<template>
  <div class="new-workload-to-existing-opp">
    <div class="workload-header">
      <v-layout
        v-if="oppregStep === 'workload' || oppregStep === 'viewOppForm' "
        row
        wrap
        align-center
        class="mx-3">
        <v-btn
          @click="goBackToList">Go Back to List</v-btn>
        <v-btn color="success" v-if="oppregStep ==='viewOppForm'" @click ="setShowWorkloadForm">View Workload</v-btn>
        <v-btn color="success" v-if="oppregStep ==='workload'" @click ="setShowOppForm">View Opportunity</v-btn>
      </v-layout>
    </div>

    <div class="workload-data">
      <div
        v-if="oppregStep === 'listing'"
        class="workload-list mt-4 mx-3 pt-4">
        <material-card
          color="orange"
          title="Opportunity Registration Requests">

          <v-layout
            row
            wrap>
            <v-flex>
              <v-layout row justify-xl-start class="search-box">
                <v-flex md3>
                  <v-menu
                      v-model="fromDateModal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="from_date"
                          label="Start Date"
                          prepend-icon="event"
                          clearable
                          readonly
                          v-on="on"
                      />
                      </template>
                      <v-date-picker
                      v-model="from_date"
                      @input="fromDateModal = false"/>
                  </v-menu>
                </v-flex>
                
                <v-flex md3>
                  <v-menu
                      v-model="endDateModal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="to_date"
                          label="End Date"
                          prepend-icon="event"
                          clearable
                          readonly
                          v-on="on"
                      />
                      </template>
                      <v-date-picker
                      v-model="to_date"
                      @input="endDateModal = false" />
                  </v-menu>
                </v-flex>
                
                <v-spacer />
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  sm4
                  md4
                  xl4
                  offset-lg1
                  pt-2
                  ml-3>
                  <label>DXC SFDC Opportunity ID:</label>
                  <v-text-field
                    v-model.trim="opportunityId"
                    solo
                    placeholder="DXC SFDC OPPORTUNITY ID"/>
                  <label>Customer Name:</label>
                  <v-text-field
                    v-model.trim="Customer_Name"
                    solo
                    placeholder="CUSTOMER NAME"/>
                  <v-btn
                    :loading="newOppRegistration.searching"
                    color="success"
                    @click="filterOppRegRequestData">Search</v-btn>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  xl2
                  offset-lg1
                  ml-3>
                  <h4>Choose Region</h4>
                  <v-radio-group v-model="ESRegion">
                    <template v-for="item in filteredRegions">
                      <v-radio
                        :label="item"
                        :value="item"
                        color="orange"/>
                    </template>
                  </v-radio-group>

                </v-flex>

                <v-flex
                  xs13
                  sm3
                  md3
                  xl3
                  mx-3>
                  <h4>Choose Status</h4>
                  <v-select
                      v-model="Workload_Status"
                      :items="filteredWorkBookStatus"
                      label="Filter by Status"
                      solo
                      attach/>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  xl2>
                  <h4>Choose Form</h4>
                  <v-radio-group v-model="ViewType">
                    <template v-for="item in filteredViewTypeList">
                      <v-radio
                        :label="item"
                        :value="item"
                        color="orange"/>
                    </template>
                  </v-radio-group>
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
          <!-- for submit multiple -->
          <v-layout
            v-show="selected.length > 0"
            align-end
            justify-end
            row
            fill-height
            class="mass-update-actions"
            transition="fade-transition">
            <v-flex
              md4
              align-self-center>
              <p class="subtitle-1 mb-0"><span class="font-weight-black">({{ selected.length }})</span> accounts selected</p>
            </v-flex>
            <p
              v-if="checkAbilityToSubmit"
              class="subtitle-1 mb-0"><span class="subtitle-1 mb-0">ERROR: {{ showError }}</span> </p>
            <v-flex
              md8
              style="text-align: right">
              <v-btn
                :disabled="checkAbilityToSubmit"
                small
                class="mr-2"
                color="orange"
                @click="viewAllReqSubmit" >Submit</v-btn>
            </v-flex>
          </v-layout>
          <!-- end submit multiple -->
          <v-data-table
            :headers="filteredWorkloadHeaders"
            :items="workloadList"
            :pagination.sync="pagination"
            :loading="newOppRegistration.searching"
            v-model="selected"
            select-all="showError"
            item-key="Project_Id"
            disable-initial-sort
          >

            <template v-slot:no-data>
              <v-alert
                v-if="!newOppRegistration.withError"
                :value="true"
                color="#000"
                icon="info">
                Loading Opportunity Registration Requests data...
              </v-alert>
              <v-alert
                v-else-if="newOppRegistration.withError"
                :value="true"
                color="#000"
                icon="warning">
                No Opportunity Registration request found! Please check Filters and try again.
              </v-alert>
            </template>

            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <tr :active="props.selected" >
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    color="orange"
                    hide-details
                  />
                </td>
                <td>
                  <v-icon
                    small
                    title="View"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="onShowWorkload(props.item)">{{iconType}}</v-icon>
                </td>
                <td>{{ props.item.OppReg_Id }}</td>
                <td>{{ props.item.SFDC_Oppty_Name }}</td>
                <td>{{ props.item.Workload_Title }}</td>
                <td>{{ props.item.Workload_Status }}</td>
                <td>{{ props.item.Campaign_Name }}</td>
                <td>{{ props.item.Workload_type }}</td>
                <td>{{ props.item.Customer_Name }}</td>
                <td>{{ props.item.Global_Registered }}</td>
                <td>{{ props.item.AWS_ACE_ID }}</td>
                <td>{{ props.item.Customer_Region }}</td>
                <td>{{ props.item.Country }}</td>
                <td>{{ props.item.SignDate }}</td>
                <td>{{ props.item.Q4 }}</td>
                <td>{{ props.item.AWS_Notes}}</td>
                <td>{{ props.item.SFDC_Sales_Stage }}</td>
                <td>{{ props.item.Date_Created }}</td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </div>
      <formUserOppregForm v-if="oppregStep==='viewOppForm'" :type="newOppRegistration.type"/>
      <formUserOppregWorkload
        v-if="oppregStep === 'workload'"
        :sfdc-id="opportunityId"
        :type="newOppRegistration.type"
        :view="'user'" />
    </div>
  </div>
</template>
<script>

import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  $_veeValidate: { validator: 'new' },
  data () {
    return {
      // sfdcId: '',
      fromDateModal: false,
      endDateModal: false,
      from_date: '',
      to_date: '',
      opportunityId: '',
      Customer_Name: '',
      ESRegion: '',
      Workload_Status: '',
      ViewType: '',
      selected: [],
      showError: 'Unable to submit, please check Workload Statuses upon submission.',
      regions: ['All Region', 'Americas', 'UKI', 'Europe', 'APJ-MEA', 'Luxoft'],
      initiatives: ['Glacier Campaign', 'Global Register Initiative'],
      WorkBookStatus: [
        'All',
        'Ready for Submission',
        'Submitted by User',
        'AWS Reg Accepted',
        'Incomplete/Under Review',
        'Submitted to AWS',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Approved - Tier 2 - Custom EDP',
        'LEGACY - Internal - Tier 1 23% - PPA',
        'Disqualified - AWS forecast conflict',
        'Shareshift',
        'Disqualified - Incomplete',
        'Disqualified - No AWS scope',
        'OppReg Closed',
        'Opp Owner Email Sent',
        'Opp Owner Rejected'
      ],
      viewTypeList: ['Simple', 'Expanded'],
      iconType: '',
      pagination: {
        descending: true,
        sortBy: 'Date_Created',
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  mounted () {
    this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
    this.$store.dispatch('user/requestOppreg/getOppRegRequestData', { })
    this.iconType = 'visibility'
    this.from_date =  moment().subtract(30, 'days').format('YYYY-MM-DD')
    this.to_date = moment().format('YYYY-MM-DD')
  },
  created() {
    console.log("WORKLOAD LIST")
    console.log(this.workloadList)
  },
  computed: {
    ...mapState('user/requestOppreg', ['sfdcId', 'OppRegRequestHeaders', 'workloadList', 'newOppRegistration', 'oppregStep']),
    // opportunityId: {
    //   get: function () {
    //     return this.sfdcId
    //   },
    //   set: function (id) {
    //     this.$store.commit('user/requestOppreg/setSfdcId', id)
    //   }
    // },
    filteredWorkloadHeaders () {
      return this.OppRegRequestHeaders
    },
    filteredRegions () {
      return this.regions
    },
    filteredWorkBookStatus () {
      return this.WorkBookStatus
    },
    filteredViewTypeList () {
      return this.viewTypeList
    },
    checkAbilityToSubmit () {
      let loadToSubmit = [
        'Incomplete/Under Review',
        'Approved - Tier 3 12%',
        'Submitted by User',
        'Approved - Tier 1 23% - PPA',
        'Submitted to AWS',
        'Disqualified - Incomplete',
        'Disqualified – AWS forecast conflict']
      let validateSubmit = false

      for (var i = 0; i < this.selected.length; i++) {
        let toSubmit = loadToSubmit.includes(this.selected[i].Workload_Status)
        console.log(this.selected[i].Project_Id)
        console.log(toSubmit)
        if (toSubmit) {
          validateSubmit = true
          break
        }
      }
      return validateSubmit
    }
  },
  methods: {
    ...mapMutations({
      clearWorkloadForm: 'user/requestOppreg/clearWorkloadForm',
      showNewWorkload: 'user/requestOppreg/showNewWorkload',
      setWorkloadData: 'user/requestOppreg/setWorkloadData',
      showEditWorkload: 'user/requestOppreg/showEditWorkload',
      showWorkload: 'user/requestOppreg/showWorkload',
      hideWorkload: 'user/requestOppreg/hideWorkload',
      resetNewOppRegistration: 'user/requestOppreg/resetNewOppRegistration',
      setValidatedRegistration: 'user/requestOppreg/setRegistrationIdValidation',
      // setOpportunityFound: 'user/requestOppreg/setOpportunityFound',
      delWorkloadFields: 'user/requestOppreg/delWorkloadFields'
    }),
    onSearchOpportunity () {
      console.log('searching opportunity')
      this.$store.dispatch('user/requestOppreg/getWorkloadsByOppId', this.opportunityId)
    },
    onCreateNewWorkload () {
      this.clearWorkloadForm()
      this.showNewWorkload(this.opportunityId)
    },
    onEditWorkload (workload) {
      this.setValidatedRegistration({
        loading: false,
        success: false,
        error: false,
        successMessage: '',
        validated: true
      })
      this.$store.commit('user/requestOppreg/setSfdcId', workload.OppReg_Id)
      this.$store.commit('user/requestOppreg/setWorkloadStep', 1)
      this.setWorkloadData({ ...workload })
      this.showEditWorkload(workload.OppReg_Id)
      this.$store.commit('setChangeLogRecord', {
        id: workload.Project_Id,
        changeFrom: { ...this.$store.state['user/requestOppreg'].workloadForm.fields } },
      { root: true }
      )
    },
    onShowWorkload(workload) {
      this.setValidatedRegistration({
        loading: false,
        success: false,
        error: false,
        successMessage: '',
        validated: true
      })
      this.$store.commit('user/requestOppreg/setOppregStep', 'viewOppForm')
      this.$store.commit('user/requestOppreg/setSfdcId', workload.OppReg_Id)
      this.$store.commit('user/requestOppreg/setWorkloadStep', 1)
      this.setWorkloadData({ ...workload })
      this.showWorkload(workload.OppReg_Id)

    },
    setShowWorkloadForm() {
      this.$store.commit('user/requestOppreg/setOppregStep', 'workload')
    },
    setShowOppForm() {
      this.$store.commit('user/requestOppreg/setOppregStep', 'viewOppForm')
    },
    filterOppRegRequestData () {
      this.resetNewOppRegistration()
      let  params = {
        from_date: this.from_date, 
        to_date: this.to_date,
        sfdcId: this.opportunityId,
        Customer_Name: this.Customer_Name,
        ESRegion: (this.ESRegion !== 'All Region') ? this.ESRegion : '',
        Workload_Status: (this.Workload_Status !== 'All') ? this.Workload_Status : '',
      }
    
      console.log('PARAMS', params)
      this.$store.dispatch('user/requestOppreg/getOppRegRequestData', params)
    },
    goBackToList () {
      this.clearWorkloadForm()
      this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
      // this.hideWorkload()
    },
    viewAllReqSubmit () {
      this.$store.dispatch('user/requestOppreg/submitMultipleWorkload', this.selected)
    },
    onShowLogs (workload) {
      this.$store.dispatch('showLogRecords', workload.Project_Id)
    },
    checkAbilityToEdit (status) {
      let disabledStatus = [
        'Incomplete/Under Review',
        'Approved - Tier 3 12%',
        'Submitted by User',
        'Approved - Tier 1 23% - PPA',
        'Submitted to AWS',
        'Disqualified - Incomplete',
        'Disqualified – AWS forecast conflict'
      ]
      return disabledStatus.includes(status)
    },
    // showError () {
    //   return true
    // }
  }
}

</script>

<style lang="scss" scoped>
.new-workload-to-existing-opp {
  .header-title {
    background: #000;
    color: #fff;
    padding: 0 10px;
  }
  .search-container {
    background: #000;
  }

  .search-opp-btn {
    padding: 15px 30px;
  }

  .mass-update-actions {
  background: rgba(65, 179, 223, 0.3);
}
}
</style>
